<template>
  <div v-show="item">
    <div class="title">
      <div class="index">{{ item.name }}</div>
      <div class="sx">
        <div class="total">总数:{{item.value }}</div>
        <div class="submit">
          <el-input v-model="num" :onkeyup="upperCase(this)"   @input="onChange" @focus="onFouce" name="item" @keyup.enter.native="onBuy">
            <el-button slot="append" @click="onBuy">下单</el-button>
          </el-input>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    item: null,
    index: 0,
  },
  data() {
    return {
        num:"",
    };
  },
  methods:{
      upperCase(val){
          if(isNaN(val.value) && !/^-$/.test(val.value)){
              val.value = "";
          }
          if(!/^[+-]?\d*\.{0,1}\d{0,1}$/.test(val.value)){
              val.value=val.value.replace(/\.\d{2,}$/,val.value.substr(val.value.indexOf('.'),3));
          }
      },
      onChange(val)
      {
          
      },
      onFouce()
      {
          
      },
      onBuy()
      {
          console.log("num:",this.num,"index:",this.index);
          if(this.num>0 ||this.num<0)
          {
            this.$emit("buy",this.num,this.index);
            this.num = "";
          }
          
      }
  }
};
</script>

<style lang="less" scoped>
.title {
  font-size: 13px;
  color: white;
  font-weight: bold;
  display: flex;
  padding: 0px 10px;
  .index{
      font-size: 30px;
      width:50px;
      line-height: 44px;
      text-align: center;
      box-sizing: border-box;
  }
  .sx {
    flex: 1;
    text-align: right;
    
    .total{
      line-height: 22px;
      text-align: right;
      font-size: 16px;
      color:white;
    }
    
    .submit {
        margin-left:10px; 
      text-align: center;
      /deep/.el-input__inner{
          line-height: 25px !important;
          height: 25px !important;
          
        }
    }
  }
}


</style>